import * as particles from "pixi-particles";
import * as PIXI from "pixi.js";
import {Container} from "./Container";

export class Particles extends Container {

    public readonly emitter: particles.Emitter;

    constructor(texture: PIXI.Texture | PIXI.Texture[], data: IParticleData) {
        super();

        this.emitter = new particles.Emitter(this, texture, data);
    }

    public destroy(): void {
        this.emitter.destroy();
        super.destroy();
    }
}

export interface IParticleStartEnd<T> {
    start: T;
    end: T;
}

export interface IParticleXY {
    x: number;
    y: number;
}

export interface IParticleMinMax {
    min: number;
    max: number;
}

export interface IParticleData {
    alpha: IParticleStartEnd<number>;
    scale: IParticleStartEnd<number> & {
        minimumScaleMultiplier: number,
    };
    color: IParticleStartEnd<string>;
    speed: IParticleStartEnd<number> & {
        minimumSpeedMultiplier: number,
    };
    acceleration: IParticleXY;
    maxSpeed: number;
    startRotation: IParticleMinMax;
    noRotation: boolean;
    rotationSpeed: IParticleMinMax;
    lifetime: IParticleMinMax;
    blendMode: string;
    frequency: number;
    emitterLifetime: number;
    maxParticles: number;
    pos: IParticleXY;
    addAtBack: boolean;
    spawnType: string;
    spawnRect?: { x: number, y: number, w: number, h: number };
}
